import { useEffect, useState } from "react";
import { getLocale } from "umi";
import { getWorldClock } from '@/pages/dashboard/services/multiTimezone';
import { timeZoneTransformForShow } from "@/pages/dashboard/utils/utils";
import {WorldClockData} from "@/pages/dashboard/pages/multiTimezone/_config/types";
import { useSelectorMap } from "../../utils/customHook";


const formatWorldClockData = (data: WorldClockData[], gameCode: string, timezoneType: string,getSelectorText:any) => data?.map((item: any) => {
  item.area_show_code = getSelectorText(timezoneType, item.area_code);
  item.time_zone_show = timeZoneTransformForShow(item.time_zone);
  if (timezoneType === 'country') {
    item.show_icon = true;
  }
  return item;
}) || [];

/**
 * 获取 多时区页面的 世界时钟数据
 * hook名称规范：use+接口名称+Data
 * @param props 父页面所有props
 *   timezoneType 时区类型，country 或 zone
 * @returns
 * 获取数据的逻辑：dva中有数据则取dva中的数据，否则自己通过接口请求
 */

const useWorldClockModel = (props: any) => {

  const { gameCode, timezoneType, filterLoading} = props;
  const [componentData, setComponentData] = useState({
    defaultClockDataList: [],
    customClockDataList: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const locale = getLocale();
  const { getSelectorText } = useSelectorMap();
  // 进入页面的时候
  useEffect(() => {
    getWorldClockDatas();

  }, [timezoneType]);
  const getWorldClockDatas = () => {
    setLoading(true);
    setError(false);
    const params = { game_code: gameCode, type: timezoneType };
    getWorldClock(params).then((result) => {
      if (result != null) {
        const {customized, defaults} = result;
        result.customized = customized?.filter((item: { area_code: string; }) => item?.area_code != "255") || [];
        result.customized_size = result.customized.length;
        result.defaults = defaults?.filter((item: { area_code: string; }) => item?.area_code != "255") || [];
        result.defaults_size = result.defaults.length;
                
        const defaultClockDataList = formatWorldClockData(result?.defaults, gameCode, timezoneType,getSelectorText);
    
        const customClockDataList = formatWorldClockData(result?.customized, gameCode, timezoneType,getSelectorText);
        if (customClockDataList.length > 24) {
          customClockDataList.length = 24;
        }
        setComponentData({
          defaultClockDataList,
          customClockDataList
        });
      }

    }).catch(() => {
      setError(true);
    }).finally(() => {
      setLoading(false);
    });
        

  };
    
  // 切换中英文
  useEffect(() => {
    setComponentData(({defaultClockDataList, customClockDataList}) => ({
      defaultClockDataList: defaultClockDataList.map((item: WorldClockData) => {
        item.area_show_name = getSelectorText(timezoneType, item.area_name);
        return item;
      }),
      customClockDataList: customClockDataList.map((item: WorldClockData) => {
        item.area_show_name = getSelectorText(timezoneType, item.area_name);
        return item;
      }),
    }));
  }, [locale,filterLoading]);
    
  return {
    componentData,
    setComponentData,
    loading,
    error,
  };
};

export default useWorldClockModel;
